import { Card, Tag } from "@ptsd/uikit";
import { Text, useMedia, View } from "tamagui";

import { api } from "~/utils/api";
import { CallToDoctorButton } from "~/component/feature/paywall/call-to-doctor-button";
import { IconPresent } from "~/component/feature/paywall/icons/icon-present";
import { IconShield } from "~/component/feature/paywall/icons/icon-shield";

export const AppointmentCard = () => {
  const { sm } = useMedia();
  const { data } = api.home.getDoctorInfo.useQuery();

  if (!data) {
    return null;
  }

  return (
    <Card
      onPress={(e) => {
        e.stopPropagation();
      }}
      paddingVertical={"48px"}
      margin={"$2"}
      width={"auto"}
      $gtSm={{ width: "100%" }}
      maxWidth={"600px"}
      flex={1}
    >
      <View flexGrow={1} paddingBottom={24}>
        <View flexDirection={"row"} paddingBottom={"$2.5"}>
          <Tag
            variant={"primary"}
            style={{
              background:
                "linear-gradient(90deg,rgba(0, 188, 125, 1) 0%, rgba(0, 150, 137, 1) 100%)",
            }}
            paddingVertical={"$1.2"}
            rounded="xl"
            size={"lg"}
          >
            Спеціальна пропозиція
          </Tag>
        </View>
        <Text
          fontWeight={"bold"}
          fontFamily={"$heading"}
          paddingBottom={"$1"}
          fontSize={24}
          $gtSm={{
            fontSize: 36,
          }}
        >
          Отримати консультацію фахівця ”{data.title}”
        </Text>
        <Text
          fontSize={16}
          $gtSm={{
            fontSize: 22,
          }}
          color={"#45556C"}
          fontFamily={"$body"}
          paddingBottom={"$1"}
        >
          Обговоріть результати діагностики з фахівцем {data.title} і разом
          визначте, як краще подбати про себе далі.
        </Text>
      </View>

      <View
        marginBottom="18px"
        flexDirection={sm ? "column" : "row"}
        gap={"$2"}
        padding={"24px"}
        backgroundColor={"#FFF6FB"}
        borderRadius={"$4"}
        borderColor={"#FDA5D5"}
        borderWidth={2}
      >
        <View>
          <IconPresent />
        </View>
        <Text fontSize={18} fontFamily={"$body"}>
          Щоб додаткова підтримка була з вами весь цей час, після запису до
          фахівця {data.title} ми відкриємо вам{" "}
          <Text color={"#CD4870"}>
            безкоштовний доступ до діагностики Healthy Mind на 3 місяці.
          </Text>
        </Text>
      </View>

      <View
        marginBottom="18px"
        flexDirection={"row"}
        gap={"$2"}
        padding={"24px"}
        borderRadius={"$4"}
        alignItems={"center"}
        borderColor={"#BEDBFF"}
        borderWidth={2}
      >
        <View>
          <IconShield />
        </View>
        <Text fontSize={16} color={"$gray-600"} fontFamily={"$body"}>
          Чим раніше звернутися за підтримкою, тим швидше можна повернути
          відчуття стабільності.
        </Text>
      </View>

      <Text
        fontSize={16}
        fontFamily={"$body"}
        marginBottom={"$2"}
        textAlign={"center"}
        fontWeight={600}
      >
        Зателефонувати в “{data.title}”:
      </Text>

      <CallToDoctorButton phoneNumber={data.phoneNumber} />
    </Card>
  );
};
